import React from 'react';
import { Box } from '@mui/material';
import ReviewerCompetency from '../../EmployeesRepository/EmployeeForm/components/AssignmentDetails/components/ReviewerCompetency';

const CompetencyDisplay = ({ competencyLevelId, skillLevels }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ maxWidth: '150px' }}>
        <ReviewerCompetency 
          reviewer={{ employee: { fullName: '' } }}
          competencyLevelId={competencyLevelId}
          opacity={0.8}
          hideReviewer={true}
          skillLevels={skillLevels}
        />
      </Box>
    </Box>
  );
};

export default CompetencyDisplay; 